// extracted by mini-css-extract-plugin
export var dataCell = "_ru-2";
export var dataRow = "_ru-0";
export var headerRow = "_ru-1";